import React, { useState, useEffect, Fragment } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import { useDispatch } from "react-redux";
import OwnerDropDown from "../GlobalFeature/Fields/OwnerDropDown";
import { getCommonDataBasedOnId, saveData } from "../store/customer/CustomerSocialAddUpdateFunction";
import { ADD_CUSTOMER_DELEGATION, CUST_DELEGATION } from "../../utils/constants";
import { ADD_UPDATE_CUSTOMER_DELEGATION } from "../../utils/constants";
import FirstMessage from "../GlobalFeature/MessageAlert/FirstMessage";
import { useLazyFetchPersonInTableQuery } from "../../utils/customer/customerTable";
import { useParams } from "react-router-dom";
import { useFetchPermissionTableDataQuery } from "../../utils/company/companypermissions";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { ReactComponent as DownArrow } from "../../assets/images/downArrow.svg";
import { pushAlert } from "../../utils/alertSlice";
const AddUpdateDelegation = ({ closePopup, editData, handleSubmitData }) => {
  const token = useRequireAuth();

  const dispatch = useDispatch();
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [errors, setErrors] = useState({});
  const { id: customerId } = useParams();
  const [show, setShow] = useState("");

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const { data: permissionsData } = useFetchPermissionTableDataQuery({ token: token?.token });
  const options = permissionsData?.data?.data;

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setFormData((prevFormData) => ({ ...prevFormData, group_id: option?.group_name?.id }));
    setIsDropdownOpen(false);
  };

  const [formData, setFormData] = useState({
    email: "",
    owner: 0,
    // role: "",
  });

  const fetchTaskEditData = async (editData) => {
    const url = `${CUST_DELEGATION}${editData}`;
    const getData = await getCommonDataBasedOnId(url, token?.token);
    if (getData?.data && getData?.data?.length > 0) {
      setFormData(getData?.data[0]);
    }
  };

  useEffect(() => {
    fetchTaskEditData(editData);
  }, [editData]);

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: parseInt(value) }));
  };

  const validate = () => {
    let tempErrors = {};

    if (!formData?.email) {
      tempErrors.email = "Email is required";
    }
    if (!formData?.owner) {
      tempErrors.owner = "access is required";
    }
    // if (!selectedOption) {
    //   tempErrors.selectedOption = "Role is required";
    // }

    setErrors(tempErrors);
    return Object.keys(!tempErrors).length === 0;
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (!validate()) {
      return false;
    }
    const customerData = {
      ...formData,
      customer_id: customerId,
      company_id: parsedCompanyData.company_id,
      // id: editData,
      multiData: [customerId],
      // group_id: formData?.group_id,
    };

    const response = await saveData(ADD_CUSTOMER_DELEGATION, [customerData], token?.token);

    if (response?.status) {
      handleSubmitData();
      dispatch(pushAlert({ type: "success", message: "Business Caterory Added Successfully", visible: true }));
      closePopup();
    } else {
      setShow(response?.message);
      dispatch(pushAlert({ type: "success", message: `${response?.message}`, visible: true }));
    }
  };
  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };

  const handleInsert = (item) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      email: item,
    }));
  };

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonInTableQuery();

  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: token?.token, data: data, companyId: parsedCompanyData.company_id });
  };
  const tableDetail = {
    tableidclass: "usermodelmember",
  };
  setTimeout(() => {
    setShow("");
  }, 4000);

  return (
    <Fragment>
      <div className="fixed inset-y-0 z-[999] grid h-screen place-items-center justify-start">
        <div className="relative  py-2 mt-18 bg-white border border-E5ECF0 font-popns drop-shadow-lg  rounded-md w-500px overflow-hidden no-scrollbar ">
          <div className=" flex items-center justify-between  pr-3 pl-2 pb-2 border-BECBD3 rounded-t">
            <div className="px-2"></div>
            <br />
            <h3 className="text-16 font-500 text-434852">
              {" "}
              {editData ? "Edit Customer Delegation" : "Add Customer Delegation"}
            </h3>

            <button
              onClick={closePopup}
              type="button"
              className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
              data-modal-hide="assets-modal"
            >
              {/* <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg> */}
              <CloseModalImg className="w-3 h-3" />
              <span className="sr-only">Close modal</span>
            </button>
          </div>

          <form onSubmit={handleSave} className="w-full lg:max-h-[70vh]  overflow-x-hidden  no-scrollbar">
            <div className="basis-5/5 mb-3 px-6 ">
              <label htmlFor="first_name" className="block text-lg border-t pt-2">
                <span className="text-sm  text-434852 font-400">Email</span>
                <span className=" text-red-500"> *</span>
                {errors.email && <span className="text-red-700 text-12 ">{errors.email}</span>}
              </label>
              <OwnerDropDown
                tableidclass={tableDetail.tableidclass}
                fetchPersonInTable={fetchPersonData}
                DropData={personTableData}
                handleInsert={handleInsert}
                owner={formData?.email}
                fieldname={"owner"}
              />
              {show && <span className="text-red-700">{show}</span>}
            </div>
            <div className="basis-5/5 mb-3 px-6 ">
              <label htmlFor="Designation" className="block mb-1 text-sm font-400 text-434852">
                Access <span className=" text-red-500 "> *</span>
                {errors.owner && <span className="text-red-700">{errors.owner}</span>}
              </label>
              <select
                id={`owner`}
                name="owner"
                onChange={handleFieldChange}
                className={`form-select  bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E text-gray-900 text-xs block w-full px-2.5 py-0.5`}
              >
                <option value="0" selected={parseInt(formData?.owner) === 0}>
                  Contributor
                </option>
                <option value="1" selected={parseInt(formData?.owner) === 1}>
                  Owner
                </option>
              </select>
            </div>

            {false && (
              <div className="basis-5/5 mt-3 px-6 pb-2 pt-1">
                <div className="flex">
                  <label className="block mb-1 text-13 font-400 text-434852">
                    Assign Role<span className=" text-red-500"> *</span>
                  </label>
                  {errors.selectedOption && <span className="text-red-700 text-12">{errors.selectedOption}</span>}
                </div>
                <div
                  className={`flex justify-between items-center h-[30px] p-1 border ${
                    isDropdownOpen ? "border-1D5D9B" : "border-DFE2E5"
                  } bg-white cursor-pointer rounded-[5px] px-2 text-383838 text-12 font-400 w-full`}
                  onClick={toggleDropdown}
                >
                  {selectedOption ? (
                    selectedOption.group_name.value
                  ) : (
                    <span className="text-gray-300 font-500">Assign Role</span>
                  )}
                  <span className={`transition-transform ${isDropdownOpen ? "rotate-180" : ""}`}>
                    <DownArrow fill="#535252" />
                  </span>
                </div>

                {isDropdownOpen && (
                  <div className="fixed z-[1050] w-[450px] border border-gray-300 bg-white shadow-lg rounded-[5px]  text-383838 text-12 font-400">
                    {options.map((option, index) => (
                      <div
                        key={index}
                        className="cursor-pointer hover:bg-gray-300 p-1 px-2"
                        onClick={() => handleOptionSelect(option)}
                      >
                        {option.group_name.value}
                      </div>
                    ))}
                  </div>
                )}
                {selectedOption && <p className=" font-bold">{selectedOption.value}</p>}
              </div>
            )}

            <div className="flex justify-end pb-1 text-md w-full">
              <div className="px-6">
                <button
                  onClick={closePopup}
                  type="button"
                  className="w-28 text-535252 bg-F4F4F4 hover:bg-[#EBF2F6] cancel-btn focus:ring-4 focus:ring-blue-300 font-semibold px-5 py-1 text-center rounded-[5px]"
                >
                  CANCEL
                </button>
                {editData ? (
                  <button
                    type="submit"
                    className="w-28 text-white bg-[#1D4469] hover:bg-[#092239] save-btn font-semibold  border border-gray-200 py-1 px-5 ms-3 rounded-[5px]"
                  >
                    UPDATE
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="w-28 text-white bg-[#1D4469] hover:bg-[#092239] save-btn font-semibold  border border-[#123251] py-1 px-5 ms-3 rounded-[5px]"
                  >
                    SAVE
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

export default AddUpdateDelegation;
